import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export interface CompactStatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: { value: number; positive: boolean };
  className?: string;
  iconClassName?: string;
  compact?: boolean;
}

const CompactStatCard = ({
  title,
  value,
  icon: Icon,
  trend,
  className,
  iconClassName,
  compact = true,
}: CompactStatCardProps) => {
  return (
    <div
      className={cn(
        "glass-card rounded-xl border border-border transition-shadow hover:shadow-md",
        compact ? "p-3" : "p-4",
        className
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-0.5">
          <p className="truncate text-[11px] font-medium text-muted-foreground sm:text-xs">{title}</p>
          <p
            className={cn(
              "font-heading font-bold tracking-tight text-foreground tabular-nums break-words",
              compact ? "text-base sm:text-lg" : "text-xl sm:text-2xl",
            )}
          >
            {value}
          </p>
          {trend && (
            <p className={cn("text-[11px] font-medium", trend.positive ? "text-success" : "text-destructive")}>
              {trend.positive ? "↑" : "↓"} {Math.abs(trend.value)}% from last month
            </p>
          )}
        </div>
        <div
          className={cn(
            "flex shrink-0 items-center justify-center rounded-lg",
            compact ? "h-8 w-8" : "h-10 w-10",
            iconClassName || "bg-primary/10"
          )}
        >
          <Icon className={cn(compact ? "h-3.5 w-3.5" : "h-4 w-4", iconClassName ? "text-primary-foreground" : "text-primary")} />
        </div>
      </div>
    </div>
  );
};

export default CompactStatCard;
